<template>
    <div class="report__page">
        <h2>Report Details</h2>
        <ReportDetailsSelector v-if="isLocationReport" :details="customDetailsLocations" :is-compact="true" />
        <ReportDetailsSelector v-else :details="customDetailsAssets" :is-compact="true" />
        <!-- LAST MAINTAINED / ATTENDED LOG -->
    </div>
</template>

<script>
import ReportDetailsSelector from './ReportDetailsSelector.vue';

export default {
    components: {
        ReportDetailsSelector
    },

    data() {
        return {
            customDetailsLocations: [
                { value: 'site_name', label: 'Site' },
                { value: 'asset_id', label: 'ID' },
                { value: 'name', label: 'Name' },
                { value: 'asset_type', label: 'Asset Type' },
                { value: 'location_reference', label: 'Location Reference' },
                { value: 'area', label: 'Area' },
                { value: 'location', label: 'Sub Area' },
                { value: 'description', label: 'Description' },
                { value: 'additional_info', label: 'Additional Info' },
                { value: 'last_maintained_date', label: 'Last Maintained/Attended Date' },
                { value: 'maintenance_schedule_start_date', label: 'Maintenance Schedule Start Date' },
                { value: 'maintenance_current_status', label: 'Maintenance/Attendance Status' },
                { value: 'maintenance_current_user', label: 'Maintenance/Attendance User' },
                { value: 'maintenance_current_company', label: 'Maintenance/Attendance Company' },
                { value: 'maintenance_current_notes', label: 'Maintenance/Attendance Notes' },
            ],
            customDetailsAssets: [
                { value: 'site_name', label: 'Site' },
                { value: 'asset_id', label: 'ID' },
                { value: 'name', label: 'Name' },
                { value: 'asset_type', label: 'Asset Type' },
                { value: 'area', label: 'Area' },
                { value: 'location', label: 'Sub Area' },
                { value: 'description', label: 'Description' },
                { value: 'last_maintained_date', label: 'Last Maintained/Attended Date' },
                { value: 'maintenance_schedule_start_date', label: 'Maintenance Schedule Start Date' },
                { value: 'maintenance_current_status', label: 'Maintenance/Attendance Status' },
                { value: 'maintenance_current_user', label: 'Maintenance/Attendance User' },
                { value: 'maintenance_current_company', label: 'Maintenance/Attendance Company' },
                { value: 'maintenance_current_notes', label: 'Maintenance/Attendance Notes' },
            ]
        }
    },

    computed: {
        isLocationReport() {
            return this.$store.getters['createCustomReport/getMaintenanceSelectedAssetType'] === 'Location'
        }
    }
}
</script>

<style lang="scss" scoped>
.report__page {
    height: 100%;
    padding: 0.5rem;

    h2 {
        padding-left: 1rem;
        margin: 0;
    }
}
</style>